export default __webpack_public_path__ + "static/media/topic900.f1977c17.png";